import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Card,
  CardContent,
  Stack,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { PageHeader } from "../../components/cards/PageHeader";
import { AppColors } from "../../constants/AppColors";
import { useTranslation } from "../../translations/i18n";
import { getSupportEmailHref } from "../../utils/helperFunctions/contactSupport";

const SupportScreen = () => {
  const { t } = useTranslation();

  const items = [
    {
      question: t("faq.items.bookingSource.question"),
      answer: t("faq.items.bookingSource.answer"),
    },
    {
      question: t("faq.items.ical.question"),
      answer: t("faq.items.ical.answer"),
    },
    {
      question: t("faq.items.guests.question"),
      answer: t("faq.items.guests.answer"),
    },
    {
      question: t("faq.items.cleaning.question"),
      answer: t("faq.items.cleaning.answer"),
    },
    {
      question: t("faq.items.invoices.question"),
      answer: t("faq.items.invoices.answer"),
    },
    {
      question: t("faq.items.subscription.question"),
      answer: t("faq.items.subscription.answer"),
    },
  ];

  const handleContactSupport = () => {
    window.location.href = getSupportEmailHref();
  };

  return (
    <Box>
      <PageHeader title={t("faq.title")} description={t("faq.subtitle")} />

      <Stack spacing={1.5}>
        {items.map((item) => (
          <Accordion
            key={item.question}
            elevation={0}
            sx={{
              borderRadius: "18px !important",
              border: `1px solid ${AppColors.border}`,
              overflow: "hidden",
              "&:before": {
                display: "none",
              },
            }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography sx={{ fontWeight: 900 }}>{item.question}</Typography>
            </AccordionSummary>

            <AccordionDetails>
              <Typography color="text.secondary">{item.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))}
      </Stack>

      <Card
        elevation={0}
        sx={{
          mt: 3,
          borderRadius: 4,
          border: `1px solid ${AppColors.border}`,
        }}
      >
        <CardContent sx={{ p: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 900 }}>
            {t("faq.needHelp")}
          </Typography>

          <Typography color="text.secondary" sx={{ mt: 0.5 }}>
            {t("faq.needHelpText")}
          </Typography>

          <Typography
            onClick={handleContactSupport}
            sx={{
              mt: 1.5,
              color: AppColors.primary,
              fontWeight: 900,
              cursor: "pointer",
            }}
          >
            {t("faq.contactSupport")}
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default SupportScreen;
